<template>
  <teleport to="body">
    <div class="event-fields-select" v-if="fieldsSelect"
      :class="event.current_locale === 'en' ? 'en-class' : 'he-class'">
      <div class="fields-select-overlay">
        <div class="fields-select-body">
          <div class="fields-top">
            <div class="fields-title">
              {{ $trans("event.create.custom_fields") }}
            </div>
            <div class="fields-count">
              {{ stepForm.event_fields.length + 3 }}/{{
                constants.eventFields.length
              }}
            </div>
          </div>

          <ul class="fields-list">
            <li :key="idx" v-for="(field, idx) in constants.eventFields">
              <label>
                <input v-if="isRequiredField(field)" type="checkbox" name="event_field" :value="field"
                  v-model="stepForm.event_fields" />
                <span class="check" :class="{ fixed: !isRequiredField(field) }">
                </span>
                {{ $trans(`event.fields.field_${field}`) }}
                <small v-if="!isRequiredField(field)">({{ $trans("event.fields.must") }})</small>
              </label>
            </li>
          </ul>

          <button class="fields-finish" @click="closeFieldsSelect">
            {{ $trans("event.fields.close") }}
          </button>
        </div>
      </div>
    </div>

    <app-crop-image v-if="middleImageCrop" :image="stepForm.middle_image"
      :text="$trans('event.create.player_image_crop')" :min-width="1920" :min-height="500" :debounce="10"
      @close="closeMiddleImageCrop" @crop="cropMiddleImageFinish" />

    <app-crop-image v-if="bottomImageCrop" :image="stepForm.bottom_image"
      :text="$trans('event.create.player_image_crop')" :min-width="1920" :min-height="500" :debounce="10"
      @close="closeBottomImageCrop" @crop="cropBottomImageFinish" />

    <app-crop-image v-if="lecturerCrop" :image="stepForm.lecturer_image" :stencil-props="{
      aspectRatio: 10 / 10,
    }" :min-width="100" :text="$trans('event.create.player_image_crop')" :min-height="100" :max-width="1000"
      :max-height="1000" :debounce="100" @close="closeLecturerCrop" @crop="cropLecturerFinish" />

    <app-crop-image v-if="coverCrop" :image="stepForm.cover_image ? stepForm.cover_image : stepForm.pixabay_image
      " :text="$trans('event.create.player_image_crop')" :aspect-ratio="16 / 9" :min-width="1920" :min-height="1080"
      :debounce="10" @close="closeCoverCrop" @crop="cropCoverFinish" @change="cropCoverChange" />
  </teleport>
  <div class="event-details">
    <template v-if="stepForm.type && stepForm.type.length">
      <div class="event-details-tabs">
        <!--            <div class="event-details-indicator" :class="{'details': onDetails}"></div>-->
        <a :class="{ active: !onDetails }" @click.prevent="setOnDetails(false)">
          {{ $trans("event.create.upload_event_cover_image") }}
          <div v-html="$icon('upload')"></div>
        </a>
        <a :class="{ active: onDetails }">
          {{ $trans("event.create.edit_event_details") }}
          <div v-html="$icon('details')"></div>
        </a>
      </div>
      <div class="event-padding no-bottom">
        <div class="event-type-select" v-click-outside="() => (showTypeOptions = false)">
          <div @click="toggleTypeOptions" class="type-select-dropdown">
            <span class="selected-icon" :class="stepForm.type"></span>
            <div class="selected-info">
              <span class="selected-text">{{
                $trans("event.create.selected_type")
              }}</span>
              <span class="selected-type-name">{{
                constants.eventTypeTitle[stepForm.type]
              }}</span>
            </div>
          </div>
          <transition name="fade">
            <div v-if="showTypeOptions" class="type-select-options">
              <div @click="selectType(eventType)" :key="label" v-for="(label, eventType) in constants.eventType"
                class="select-type-item">
                <div class="type-title">
                  {{ constants.eventTypeTitle[eventType] }}
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div v-if="onDetails" class="event-padding">
        <div class="event-group-item">
          <div class="form-group">
            <div class="flex-items">
              <!--                        <div class="flex-item">-->
              <!--                        <app-select-->
              <!--                            :error="errors.get('event_category')"-->
              <!--                            v-model="stepForm.event_category">-->
              <!--                            <option value="" disabled>{{ $trans('event.create.category') }}</option>-->
              <!--                            <option v-for="(label, option) in constants.categories" :value="option" :key="option">{{ label }}</option>-->
              <!--                        </app-select>-->
              <!--                        </div>-->
              <div class="flex-item">
                <!-- <app-input
                                    :error="errors.get('event_name')"
                                    v-model="stepForm.event_name"
                                    :placeholder="$trans('event.create.name')"
                                >
                                </app-input> -->

                <app-textarea :error="errors.get('event_name')" v-model="stepForm.event_name"
                  :placeholder="$trans('event.create.name')">
                </app-textarea>
              </div>
            </div>
          </div>
          <transition name="fade">
            <div class="form-group" v-if="stepForm.has_event_dates">
              <div class="flex-items force">
                <div class="flex-item">
                  <app-input id="start_date" is-date-picker date-format="DD/MM/YYYY" :error="errors.get('start_date')"
                    v-model="stepForm.start_date" start-icon="datepicker" icon="cancel" :icon-clickable="true"
                    @click="clearStartDate" :placeholder="$trans('event.create.start_date')"></app-input>
                </div>
                <div class="flex-item">
                  <app-input id="end_date" is-date-picker date-format="DD/MM/YYYY" :error="errors.get('end_date')"
                    v-model="stepForm.end_date" start-icon="datepicker" icon="cancel" :icon-clickable="true"
                    @click="clearEndDate" :disabled="!stepForm.start_date"
                    :placeholder="$trans('event.create.end_date')"></app-input>
                </div>
              </div>
            </div>
          </transition>
          <transition name="fade">
            <div class="form-group" v-if="stepForm.has_event_times">
              <div class="flex-items force">
                <div class="flex-item">
                  <app-input id="start_time" is-time-picker :error="errors.get('start_time')"
                    v-model="stepForm.start_time" start-icon="time" icon="cancel" :icon-clickable="true"
                    @click="clearStartTime" :placeholder="$trans('event.create.start_time')"></app-input>
                </div>
                <div class="flex-item">
                  <app-input id="end_time" is-time-picker :disabled="!stepForm.start_time"
                    :error="errors.get('end_time')" v-model="stepForm.end_time" start-icon="time" icon="cancel"
                    :icon-clickable="true" @click="clearEndTime"
                    :placeholder="$trans('event.create.end_time')"></app-input>
                </div>
              </div>
            </div>
          </transition>
          <div class="add-date-time" v-if="stepForm.type === 'save_spot'">
            <div class="add-toggle" @click="toggleTimes" v-html="addTimes"></div>
            <div class="add-toggle" @click="toggleDates" v-html="addDates"></div>
          </div>

          <div class="form-group" v-if="stepForm.type === 'save_spot'">
            <app-select @focus="
              () => {
                window.eventBus.emit(
                  'sideBySide',
                  'info_bar'
                );
              }
            " :error="errors.get('location_type')" v-model="stepForm.location_type">
              <option value="-1" disabled>{{
                $trans("event.create.location_type")
              }}</option>
              <option v-for="(label,
                option) in constants.eventLocationType" :value="option" :key="option">{{ label }}
              </option>
            </app-select>
          </div>
          <div class="form-group" v-if="stepForm.location_type === constants.online">
            <div class="flex-items force">
              <div class="flex-item">
                <app-input :error="errors.get('meeting_url')" v-model="stepForm.meeting_url" :placeholder="$trans('event.create.meeting_url')
                  "></app-input>
              </div>
              <div class="flex-item">
                <app-input :error="errors.get('meeting_password')" v-model="stepForm.meeting_password" :placeholder="$trans('event.create.meeting_password')
                  "></app-input>
              </div>
            </div>
          </div>
          <div class="form-group" v-if="stepForm.location_type === constants.offline">
            <app-input id="event-location" start-icon="location" :address="true" :short-address="true"
              :error="errors.get('location')" v-model="stepForm.location"
              :placeholder="$trans('event.create.location')"></app-input>
          </div>

          <div class="form-group event-description">
            <!--                <app-textarea-->
            <!--                    :error="errors.get('description')"-->
            <!--                    v-model="stepForm.description"-->
            <!--                    :placeholder="$trans('event.create.description')">-->
            <!-- </app-textarea> -->
            <!---->
            <vue-editor :placeholder="$trans('event.create.description')" :editor-toolbar="customToolbar"
              v-model="stepForm.description" @focus="
                () => {
                  window.eventBus.emit('sideBySide', 'description');
                }
              "></vue-editor>
          </div>
        </div>
        <div class="event-group-item">
          <div class="middle-element-top">
            <div class="middle-element-title">
              {{ $trans("event.create.add_middle_element") }}
            </div>
            <div class="middle-element-toggle">
              <span v-html="$trans('event.create.yes')"></span>
              <app-toggle id="show_middle_image" v-model="stepForm.show_middle_image"></app-toggle>
              <span v-html="$trans('event.create.no')"></span>
            </div>
          </div>
          <div v-if="stepForm.show_middle_image">
            <div class="form-group">
              <div class="flex-item">
                <div class="flex-item">
                  <app-file :error="errors.get('middle_image')" start-icon="upload" v-model="stepForm.middle_image"
                    v-model:imageName="stepForm.middle_image_name" :placeholder="$trans('event.create.upload_image')">
                  </app-file>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- SpinToWin Integration -->
        <div v-if="event && event.is_from_spin_to_win" class="event-group-item spintowin-wrap">
          <div class="middle-element-top">
            <div class="middle-element-title">
              {{ $trans("event.create.add_spintowin") }}
            </div>
            <div class="middle-element-toggle">
              <span v-html="$trans('event.create.yes')"></span>
              <app-toggle id="spintowin_enabled" v-model="stepForm.spintowin_enabled"></app-toggle>
              <span v-html="$trans('event.create.no')"></span>
            </div>
          </div>
          <div v-if="stepForm.spintowin_enabled">
            <div class="form-group">
              <app-select @focus="() => { window.eventBus.emit('sideBySide', 'spintowin'); }"
                :error="errors.get('spintowin_position')" v-model="stepForm.spintowin_position">
                <option value="" disabled>{{ $trans("event.create.spintowin_position") }}</option>
                <option v-for="(label, pos) in constants.spintowinPositions" :value="pos" :key="pos">
                  {{ label }}
                </option>
              </app-select>
            </div>
            <div class="form-group">
              <app-input @focus="() => { window.eventBus.emit('sideBySide', 'spintowin'); }"
                :error="errors.get('spintowin_token')" v-model="stepForm.spintowin_token"
                :placeholder="$trans('event.create.spintowin_token_placeholder')"></app-input>
            </div>
          </div>
        </div>

        <!-- first description -->
        <div class="event-group-item">
          <div class="extra-description-top">
            <div class="extra-description-title">
              {{ $trans("event.create.add_extra_description") }}
            </div>
            <div class="extra-description-toggle">
              <span v-html="$trans('event.create.yes')"></span>
              <app-toggle id="show_extra_description" v-model="stepForm.show_extra_description"></app-toggle>
              <span v-html="$trans('event.create.no')"></span>
            </div>
          </div>
          <div v-if="stepForm.show_extra_description" class="form-group event-description">
            <vue-editor :placeholder="$trans('event.create.description')" :editor-toolbar="customToolbar"
              v-model="stepForm.extra_description" @focus="
                () => {
                  window.eventBus.emit('sideBySide', 'extra-description');
                }
              "></vue-editor>
          </div>
        </div>
        <!-- second image -->
        <div class="event-group-item">
          <div class="middle-element-top">
            <div class="middle-element-title">
              {{ $trans("event.create.add_bottom_element") }}
            </div>
            <div class="middle-element-toggle">
              <span v-html="$trans('event.create.yes')"></span>
              <app-toggle id="show_bottom_image" v-model="stepForm.show_bottom_image"></app-toggle>
              <span v-html="$trans('event.create.no')"></span>
            </div>
          </div>
          <div v-if="stepForm.show_bottom_image">
            <div class="form-group">
              <div class="flex-item">
                <div class="flex-item">
                  <app-file :error="errors.get('bottom_image')" start-icon="upload" v-model="stepForm.bottom_image"
                    v-model:imageName="stepForm.bottom_image_name" :placeholder="$trans('event.create.upload_image')">
                  </app-file>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- second description -->
        <div class="event-group-item">
          <div class="extra-description-top">
            <div class="extra-description-title">
              {{ $trans("event.create.add_extra_description") }}
            </div>
            <div class="extra-description-toggle">
              <span v-html="$trans('event.create.yes')"></span>
              <app-toggle id="show_second_extra_description"
                v-model="stepForm.show_second_extra_description"></app-toggle>
              <span v-html="$trans('event.create.no')"></span>
            </div>
          </div>
          <div v-if="stepForm.show_second_extra_description" class="form-group event-description">
            <vue-editor :placeholder="$trans('event.create.description')" :editor-toolbar="customToolbar"
              v-model="stepForm.second_extra_description" @focus="
                () => {
                  window.eventBus.emit('sideBySide', 'extra-description');
                }
              "></vue-editor>
          </div>
        </div>

        <!-- payment feild   -->
        <div class="event-group-item" :class="[classOne]">
          <div class="form-group">
            <app-select :error="errors.get('payment_required')" v-model="stepForm.payment_required">
              <option value="-1" disabled>
                {{ $trans("event.create.payment_required") }}
              </option>
              <option :value="1">
                {{ $trans("event.create.yes_payment") }}
              </option>
              <option :value="0">
                {{ $trans("event.create.no_payment") }}
              </option>
              <option :value="2">
                {{ $trans("event.create.hide_payment") }}
              </option>
            </app-select>
          </div>
          <div class="form-group" v-if="stepForm.payment_required === 1">
            <div class="flex-items force">
              <div class="flex-item-auto w-35">
                <app-select :error="errors.get(`payment_type`)" v-model="stepForm.payment_type">
                  <option v-for="(label, option) in constants.paymentTypes" :value="option" :key="option">
                    {{ label }}
                  </option>
                </app-select>
              </div>
              <div class="flex-item-auto w-65">
                <app-input :start-icon="constants.paymentTypeIcon[stepForm.payment_type]"
                  :error="errors.get('payment_url')" v-model="stepForm.payment_url" :placeholder="$trans(`event.create.payment_url_${stepForm.payment_type}`)
                    "></app-input>
              </div>
            </div>
          </div>
        </div>

        <div class="event-group-item lecturer-wrap-inner">
          <div class="lecturer-top">
            <div class="lecturer-title">
              {{ $trans("event.create.add_lecturer_details") }}
            </div>
            <div class="lecturer-toggle">
              <span v-html="$trans('event.create.yes')"></span>
              <app-toggle id="has-lecturer" v-model="stepForm.has_lecturer"></app-toggle>
              <span v-html="$trans('event.create.no')"></span>
            </div>
          </div>
          <div v-if="stepForm.has_lecturer" class="lecturer-fields">
            <div class="form-group">
              <div class="flex-items">
                <div class="flex-item">
                  <app-input :error="errors.get('lecturer_name')" :disabled="!stepForm.has_lecturer"
                    v-model="stepForm.lecturer_name"
                    :placeholder="$trans((stepForm.type === 'contact_me' || stepForm.type === 'guide_download') ? 'event.create.lecturer_tad_name' : 'event.create.lecturer_name')">
                  </app-input>
                </div>
                <div class="flex-item">
                  <app-file :error="errors.get('lecturer_image')" start-icon="upload" v-model="stepForm.lecturer_image"
                    v-model:imageName="stepForm.lecturer_image_name"
                    :placeholder="$trans((stepForm.type === 'contact_me' || stepForm.type === 'guide_download') ? 'event.create.lecturer_tad_image' : 'event.create.lecturer_image')">
                  </app-file>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="flex-items">
                <div class="flex-item">
                  <app-input :disabled="!stepForm.has_lecturer
                    " :error="errors.get('lecturer_desc')" v-model="stepForm.lecturer_desc"
                    :placeholder="$trans((stepForm.type === 'contact_me' || stepForm.type === 'guide_download') ? 'event.create.lecturer_tad_desc' : 'event.create.lecturer_desc')">
                  </app-input>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="event-group-item" v-if="stepForm.type === 'guide_download'">
          <div class="form-group">
            <div class="flex-items">
              <div class="flex-item">
                <app-file
                  :error="errors.get('guide_pdf')"
                  start-icon="upload"
                  accept=".pdf"
                  v-model="stepForm.guide_pdf"
                  v-model:imageName="stepForm.guide_pdf_name"
                  :placeholder="$trans('event.create.guide_pdf_placeholder')"
                >
                </app-file>
              </div>
            </div>
          </div>
        </div>

        <div class="event-group-item registration-fields">
          <div class="fields-top">
            <div class="fields-title">
              {{ $trans("event.create.custom_fields") }}
            </div>
            <div class="fields-count">
              {{ stepForm.event_fields.length + 3 }}/{{
                constants.eventFields.length
              }}
            </div>
          </div>
          <!--  <div class="fields-select-toggle" @click="fieldsSelect = true">
            <span class="placeholder">{{
              $trans("event.create.select_fields")
            }}</span>
          </div>-->
          <app-multi-select @focus="
            () => {
              window.eventBus.emit('sideBySide', 'fields');
            }
          " :placeholder="$trans('event.create.select_fields')" :options="constants.eventFields"
            v-model="stepForm.event_fields"></app-multi-select>
          <div class="fields-bottom">
            <div class="bottom-title">
              {{ $trans("event.create.fields_more_than_one") }}
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="!onDetails" class="event-padding full-height">
        <div class="upload-event-cover">
          <!--                <h6>{{ $trans('event.create.event_cover_image') }}</h6>-->

          <div class="upload-event-image-select" :class="{ 'has-palette': colorPalette }">
            <input type="file" ref="imageFile" @input="onImageSelect" accept="image/*" />
            <div class="upload-image-button">
              <app-button type="button" :shrink="false" :loading="uploadingImage" icon="upload-white"
                :class="{ activated: stepForm.cover_image }" @click="openImageUpload" class="btn">{{
                  $trans("event.create.upload_image") }}</app-button>
              <app-button type="button" :shrink="false" :class="{ activated: stepForm.has_no_image }"
                v-if="!stepForm.cover_image && !stepForm.pixabay_image" @click="cancelImage()" class="btn btn-cancel">{{
                  $trans("event.create.find_me_image") }}</app-button>
              <app-button type="button" :shrink="false" v-if="stepForm.pixabay_image" @click="cancelPixabayImage"
                class="btn btn-cancel">{{ $trans("event.create.cancel_image") }}</app-button>
              <app-button type="button" :shrink="false" v-if="stepForm.cover_image" @click="cancelImageUpload"
                class="btn btn-cancel">{{ $trans("event.create.cancel_image") }}</app-button>
            </div>
            <template v-if="!stepForm.has_no_image">
              <div v-if="uploadImageErrors.get('file')">
                {{ uploadImageErrors.get("file") }}
              </div>
              <transition name="fade">
                <div v-if="stepForm.cover_image" class="preview-image">
                  <app-button type="button" :shrink="false" @click="initCropImage" class="btn btn-crop">{{
                    $trans("event.create.crop_image") }}</app-button>

                  <img id="coverImage" :src="stepForm.cover_image" alt="" />
                </div>
              </transition>
            </template>
            <template v-else>
              <div class="upload-image-pixabay">
                <div class="pixabay-note" v-if="!stepForm.pixabay_image" v-html="$trans('event.create.pixabay_note')">
                </div>

                <div v-if="stepForm.pixabay_image" class="preview-pixabay-image">
                  <app-button type="button" :shrink="false" @click="initCropImage" class="btn btn-crop">{{
                    $trans("event.create.crop_image") }}</app-button>

                  <img id="pixabayImage" :src="stepForm.pixabay_image" alt="" />
                </div>

                <pixabay v-if="!stepForm.pixabay_image" @update:image="setPixabayImage" @update:query="setPixabayQuery"
                  :query="pixabayQuery" :no-results="$trans('event.create.pixabay_no_results')"
                  :placeholder="$trans('event.create.pixabay_search')" v-model:image="stepForm.pixabay_image">
                </pixabay>
              </div>
            </template>

            <template v-if="colorPalette">
              <app-select class="select-name-position" :label="$trans('event.position.select')"
                :error="errors.get('name_position')" v-model="stepForm.name_position">
                <option value="center">
                  {{ $trans("event.position.center") }}
                </option>
                <option value="left">
                  {{ $trans("event.position.left") }}
                </option>
                <option value="right">
                  {{ $trans("event.position.right") }}
                </option>
                <option value="bottom">
                  {{ $trans("event.position.bottom") }}
                </option>
                <option value="none">
                  {{ $trans("event.position.none") }}
                </option>
              </app-select>

              <div class="event-background-palette">
                <div class="select-color-text">
                  {{ $trans("event.create.select_dominant_color") }}
                </div>
                <div class="pallete-items-wrap">
                  <div class="palette-item" @click="selectPaletteColor(color)" :class="{
                    selected:
                      String(stepForm.background_color) === String(color),
                  }" :style="{ backgroundColor: color }" :key="index" v-for="(color, index) in colorPalette"></div>
                  <div v-if="!colorPalette.includes(stepForm.background_color)" :style="{
                    backgroundColor: stepForm.background_color,
                  }" class="palette-item selected" @click="selectPaletteColor(stepForm.background_color)"></div>
                  <div @click="openColorPicker" class="palette-item color-picker">
                    <input id="color-picker" />
                  </div>
                </div>
              </div>
              <div class="event-background-palette text-color">
                <div class="select-color-text">
                  {{ $trans("event.create.select_text_color") }}
                </div>
                <div class="pallete-items-wrap">
                  <div class="palette-item white" :class="{
                    selected: stepForm.text_color === '#ffffff',
                  }" @click="selectTextColor('#ffffff')"></div>
                  <div class="palette-item black" :class="{
                    selected: stepForm.text_color === '#000000',
                  }" @click="selectTextColor('#000000')"></div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="event-select-type event-padding">
        <div @click="selectType(eventType)" v-for="(label, eventType) in constants.eventType" class="select-type-item">
          <!-- :key="eventType" -->
          <img :src="constants.eventTypeIcon[eventType]" alt="" />
          <div class="type-title">
            {{ constants.eventTypeTitle[eventType] }}
          </div>
          <div class="type-description">{{ label }}</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import jscolor from "../../../plugins/jscolor";

import step from "../../../mixins/step";
import Pixabay from "../../../components/Pixabay";

import { VueEditor, Quill } from "vue3-editor";

const fontSizeArr = [
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "22px",
  "24px",
  "26px",
  "28px",
  "30px",
  "32px",
  "34px",
  "36px",
  "38px",
  "40px",
  "42px",
  "44px",
  "46px",
  "48px",
];

var Size = Quill.import("attributors/style/size");
Size.whitelist = fontSizeArr;
Quill.register(Size, true);

import ColorThief from "colorthief";

import { nextTick, ref } from "vue";
import AppToggle from "../../../components/Toggle";
import queryString from "../../../plugins/query-string-object";

import Croppr from "croppr";
window.Croppr = Croppr;

import { debounce } from "lodash";
import AppMultiSelect from "../../../components/MultiSelect";
import AppFile from "../../../components/File.vue";

function hex_is_light(color) {
  const hex = color.replace("#", "");
  const c_r = parseInt(hex.substr(0, 2), 16);
  const c_g = parseInt(hex.substr(2, 2), 16);
  const c_b = parseInt(hex.substr(4, 2), 16);
  const brightness = (c_r * 299 + c_g * 587 + c_b * 114) / 1000;

  return brightness > 210;
}

export default {
  name: "EventDetails",
  emits: ["pushState"],
  components: {
    AppFile,
    AppMultiSelect,
    AppToggle,
    Pixabay,
    VueEditor,
    debounce,
  },
  mixins: [step],
  setup() {
    const imageFile = ref(null);
    // const event = ref(window.app.event,)

    const openImageUpload = () => {
      imageFile.value.click();
    };

    return {
      imageFile,
      openImageUpload,
    };
  },
  data() {
    return {
      eventId: window.app.event.id,
      form: window.app.form,
      event: window.app.event,
      fieldsSelect: false,
      lecturerCrop: false,
      coverCrop: false,

      middleImageCrop: false,
      bottomImageCrop: false,

      draft: window.app.event.draft,
      cropper: false,
      pixabayQuery: "",
      window: window,
      uploadImageErrors: this.$api.errors(),
      uploadingImage: false,
      onDetails: false,
      colorPalette: false,
      showTypeOptions: false,
      queryParsed: false,
      colorPicker: null,
      timePickers: {
        start_time: null,
        end_time: null,
      },
      datePickers: {
        start_date: null,
        end_date: null,
      },
      customToolbar: [
        ["bold", "italic", "underline", { color: [] }],
        [{ align: "left" }, { align: "center" }, { align: "right" }],
        [{ size: fontSizeArr }],
        [{ direction: "rtl" }],
        ["clean"],
      ]
    };
  },
  mounted() {
    nextTick(() => {
      this.initPickers();
    });
    console.log("Event Fields:", this.stepForm.event_fields); // Log event fields
    console.log("Constants Event Fields:", this.constants.eventFields); // Log constants
    console.log("Form:", this.form);
    console.log("EventDetails:", this.form?.EventDetails);
    console.log("Type:", this.form?.EventDetails?.type);
    // console.log("new formm", this.form);
    console.log("new stepppp formm", this.stepForm);

    if (this.stepForm.type === "contact_me") {
      this.stepForm.payment_required = 0;
    }
    if (this.form.EventDetails.type === "contact_me") {
      this.form.EventDetails.payment_required = 0;
    }

    window.eventBus.on("saveCroppedImage", () => this.saveCroppedImage());

    window.eventBus.emit("onDetails", this.onDetails);

    window.eventBus.on(
      "onDetails",
      (onDetails) => (this.onDetails = onDetails)
    );

    window.eventBus.on("croppedImage", (base64) => {
      if (this.stepForm.has_no_image) {
        this.stepForm.pixabay_imag = base64;
      } else {
        this.stepForm.cover_image = base64;
      }
    });

    window.addEventListener("hashchange", () => {
      this.hashStepChange();
    });

    if (this.eventId && !this.draft) {
      this.$emit("pushState", {
        details: true,
        step: this.currentStep,
      });
    }

    this.hashStepChange();
  },
  watch: {
    "stepForm.event_fields"(newVal, oldVal) {
      console.log("Event Fields changed:", newVal); // Logs the updated value
    },
    fieldsSelect() {
      if (this.fieldsSelect) {
        window.eventBus.emit("sideBySide", "fields");
      }
    },
    showTypeOptions() {
      if (this.showTypeOptions) {
        window.eventBus.emit("sideBySide", "event_type");
      }
    },
    onDetails(newVal, oldVal) {
      window.eventBus.emit("onDetails", this.onDetails);
      window.eventBus.emit("sideBySide", "cover_image");

      this.$emit("pushState", {
        details: this.onDetails,
        step: this.currentStep,
      });

      $(".split-view-panel.event-steps").scrollTop(0);

      if (this.onDetails) {
        nextTick(() => {
          this.initPickers();
        });
      } else {
        this.stealCoverImageColors();

        setTimeout(() => {
          // this.initCroppr(false);
          this.initColorPicker();
        }, 1500);
      }
    },
    "stepForm.background_color"() {
      window.eventBus.emit("sideBySide", "cover_image");
    },
    "stepForm.text_color"() {
      window.eventBus.emit("sideBySide", "cover_image");
    },
    "stepForm.event_name"() {
      window.eventBus.emit("sideBySide", "event_name");
    },
    "stepForm.location"() {
      window.eventBus.emit("sideBySide", "info_bar");
    },
    "stepForm.description"() {
      window.eventBus.emit("sideBySide", "description");
    },
    "stepForm.extra_description"() {
      window.eventBus.emit("sideBySide", "extra_description");
    },
    "stepForm.lecturer_name"() {
      window.eventBus.emit("sideBySide", "lecturer");
    },
    "stepForm.lecturer_desc"() {
      window.eventBus.emit("sideBySide", "lecturer");
    },
    "stepForm.payment_type"() {
      this.stepForm.payment_url = "";
    },
    "stepForm.cover_image"(image) {
      window.eventBus.emit("sideBySide", "cover_image");

      if (!image) {
        this.colorPalette = false;
        this.stepForm.background_color = null;
        return;
      }

      this.stepForm.name_position = "bottom";
      this.stepForm.cover_image_changed = true;

      nextTick(() => {
        window.eventBus.emit("eventImageChanged", image);
      });
      this.stealCoverImageColors();
    },
    "stepForm.pixabay_image"(image) {
      window.eventBus.emit("sideBySide", "cover_image");

      if (!image) {
        this.colorPalette = false;
        this.stepForm.background_color = null;
        return;
      }

      this.stepForm.name_position = "center";
      this.stepForm.cover_image_changed = true;

      nextTick(() => {
        window.eventBus.emit("eventImageChanged", image);
      });
      this.stealCoverImageColors();
    },
    async "stepForm.middle_image"(image) {
      window.eventBus.emit("sideBySide", "middle_image");

      if (!image || !image.type) {
        this.stepForm.middle_image_changed = true;
        return;
      }

      const response = await this.$api.postFile("upload-image", image);

      if (response.hasErrors()) {
        this.toast.error(
          this.$trans("event.create.validation_error"),
          response.errors().get("file")
        );
        this.stepForm.middle_image_changed = true;
        this.stepForm.middle_image_name = null;
        this.stepForm.middle_image = null;
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        this.stepForm.middle_image_changed = true;
        this.stepForm.middle_image = e.target.result;

        this.middleImageCrop = true;
      };

      reader.readAsDataURL(image);
    },
    async "stepForm.bottom_image"(image) {
      window.eventBus.emit("sideBySide", "bottom_image");

      if (!image || !image.type) {
        this.stepForm.bottom_image_changed = true;
        return;
      }

      const response = await this.$api.postFile("upload-image", image);

      if (response.hasErrors()) {
        this.toast.error(
          this.$trans("event.create.validation_error"),
          response.errors().get("file")
        );
        this.stepForm.bottom_image_changed = true;
        this.stepForm.bottom_image_name = null;
        this.stepForm.bottom_image = null;
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        this.stepForm.bottom_image_changed = true;
        this.stepForm.bottom_image = e.target.result;

        this.bottomImageCrop = true;
      };

      reader.readAsDataURL(image);
    },
    "stepForm.guide_pdf"(file) {
      if (!file || !file.type) {
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        this.stepForm.guide_pdf = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    async "stepForm.lecturer_image"(image) {
      window.eventBus.emit("sideBySide", "lecturer");
      console.log("lecturer image EEEEE", image);
      if (!image || !image.type) {
        this.stepForm.lecturer_image_changed = true;
        return;
      }

      const response = await this.$api.postFile("upload-image", image);

      if (response.hasErrors()) {
        this.toast.error(
          this.$trans("event.create.validation_error"),
          response.errors().get("file")
        );
        this.stepForm.lecturer_image_changed = true;
        this.stepForm.lecturer_image_name = null;
        this.stepForm.lecturer_image = null;
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        this.stepForm.lecturer_image_changed = true;
        this.stepForm.lecturer_image = e.target.result;

        this.lecturerCrop = true;
      };

      reader.readAsDataURL(image);
    },
  },
  methods: {
    cancelImage() {
      this.stepForm.has_no_image = true;
      this.stepForm.name_position = "bottom";
    },
    closeFieldsSelect() {
      this.fieldsSelect = false;
    },
    isRequiredField(field) {
      return field === "first_name" || field === "email" || field === "tel";
    },
    isFieldSelected(field) {
      if (field === "first_name" || field === "email" || field === "tel") {
        return true;
      }
      return this.stepForm.event_fields.includes(field);
    },
    initCropImage() {
      nextTick(() => {
        this.initCroppr();
      });
    },
    closeMiddleImageCrop() {
      this.middleImageCrop = false;
      this.stepForm.middle_image_changed = true;
      this.stepForm.middle_image_name = null;
      this.stepForm.middle_image = null;
    },
    closeBottomImageCrop() {
      this.bottomImageCrop = false;
      this.stepForm.bottom_image_changed = true;
      this.stepForm.bottom_image_name = null;
      this.stepForm.bottom_image = null;
    },
    cropMiddleImageFinish(data) {
      if (data.image) {
        nextTick(() => {
          this.resizeImage(
            data.image.src,
            data.coordinates.width,
            data.coordinates.height,
            data.coordinates.left,
            data.coordinates.top,
            (image) => {
              this.stepForm.middle_image = image;

              this.middleImageCrop = false;
            }
          );
        });
      }
    },
    cropBottomImageFinish(data) {
      if (data.image) {
        nextTick(() => {
          this.resizeImage(
            data.image.src,
            data.coordinates.width,
            data.coordinates.height,
            data.coordinates.left,
            data.coordinates.top,
            (image) => {
              this.stepForm.bottom_image = image;
              this.bottomImageCrop = false;
            }
          );
        });
      }
    },
    closeLecturerCrop() {
      this.lecturerCrop = false;
      this.stepForm.lecturer_image_changed = true;
      this.stepForm.lecturer_image_name = null;
      this.stepForm.lecturer_image = null;
    },
    cropLecturerFinish(data) {
      if (data.image) {
        nextTick(() => {
          this.resizeImage(
            data.image.src,
            data.coordinates.width,
            data.coordinates.height,
            data.coordinates.left,
            data.coordinates.top,
            (image) => {
              this.stepForm.lecturer_image = image;

              this.lecturerCrop = false;
            }
          );
        });
      }
    },

    closeCoverCrop() {
      if (this.stepForm.cover_image) {
        window.eventBus.emit("croppingImage", this.stepForm.cover_image);
      } else {
        window.eventBus.emit("croppingImage", this.stepForm.pixabay_image);
      }
      this.coverCrop = false;
      // this.stepForm.player_image = false;
    },
    cropCoverChange(data) {
      if (data.image) {
        nextTick(() => {
          this.resizeImage(
            data.image.src,
            data.coordinates.width,
            data.coordinates.height,
            data.coordinates.left,
            data.coordinates.top,
            (image) => {
              window.eventBus.emit("croppingImage", image);
            }
          );
        });
        this.stepForm;
      }
    },
    cropCoverFinish(data) {
      if (data.image) {
        nextTick(() => {
          this.resizeImage(
            data.image.src,
            data.coordinates.width,
            data.coordinates.height,
            data.coordinates.left,
            data.coordinates.top,
            (image) => {
              if (this.stepForm.cover_image) {
                this.stepForm.cover_image = image;
              } else {
                this.stepForm.pixabay_image = image;
              }

              this.coverCrop = false;
            }
          );
        });
      }
    },

    openColorPicker() {
      if (!this.colorPicker) {
        this.initColorPicker();
      }

      nextTick(() => {
        this.colorPicker.show();
      });
    },
    initCroppr(showNotice = true) {
      if (showNotice) {
        this.toast.success(this.$trans("event.create.can_crop_image"));
      }

      this.coverCrop = true;

      return;
      if (!this.coverImageRef) {
        return;
      }

      if (this.cropper) {
        this.cropper.destroy();
      }

      this.cropper = false;

      setTimeout(() => {
        if (showNotice) {
          this.toast.success(this.$trans("event.create.can_crop_image"));
        }

        this.cropper = new Croppr(this.coverImageRef, {
          aspectRatio: 9 / 16,
          maxSize: [1920, 500, "px"],
          onCropEnd: (data) => {
            const originalImage = this.stepForm.cover_image
              ? this.stepForm.cover_image
              : this.stepForm.pixabay_image
                ? this.stepForm.pixabay_image
                : false;

            this.resizeImage(
              originalImage,
              data.width,
              data.height,
              data.x,
              data.y,
              (base) => {
                window.eventBus.emit("croppingImage", base);
              }
            );
          },
        });
      }, 100);
    },
    saveCroppedImage() {
      if (!this.cropper) {
        return;
      }

      const originalImage = this.stepForm.cover_image
        ? this.stepForm.cover_image
        : this.stepForm.pixabay_image
          ? this.stepForm.pixabay_image
          : false;

      const cropped = this.cropper.getValue();

      this.resizeImage(
        originalImage,
        cropped.width,
        cropped.height,
        cropped.x,
        cropped.y,
        (base) => {
          if (this.stepForm.cover_image) {
            this.stepForm.cover_image = base;
          } else if (this.stepForm.pixabay_image) {
            this.stepForm.pixabay_image = base;
          }

          window.eventBus.emit("croppingImage", false);
        }
      );
    },
    resizeImage(url, width, height, x, y, callback) {
      var canvas = document.createElement("canvas");
      var context = canvas.getContext("2d");
      var imageObj = new Image();

      // set canvas dimensions

      canvas.width = width;
      canvas.height = height;

      imageObj.onload = function () {
        context.drawImage(imageObj, x, y, width, height, 0, 0, width, height);
        callback(canvas.toDataURL());
      };

      imageObj.src = url;
    },

    toggleTypeOptions() {
      if (this.stepForm.type == "contact_me") {
        this.stepForm.payment_required = 0;
      } else {
        this.stepForm.payment_required = 1;
      }
      this.showTypeOptions = !this.showTypeOptions;
    },
    /**
     * Sets the type of the event in the step form and optionally toggles type options.
     * @param {string} type - The type of event to be set.
     */

    selectType(type) {
      this.stepForm.type = type;
      // constants.eventTypeTitle[stepForm.type];
      console.log("steepform", this.stepForm, type);
      if (this.stepForm.type === "contact_me") {
        console.log("StepForm contact_me triggered 950 ");
        this.stepForm.has_event_dates = false
        this.stepForm.payment_required = 0;
      } else if (this.stepForm.type === "guide_download") {
        this.stepForm.has_event_dates = false
      } else {
        this.stepForm.has_event_dates = true
      }
      if (this.showTypeOptions) {
        this.toggleTypeOptions();
      }
    },
    hashStepChange() {
      let hash = window.location.hash.substring(2);
      let parameters = hash.split("/");
      let query = hash.split("?");
      query = query.pop();
      hash = parameters.shift();

      if (query) {
        query = queryString.parse(query);

        if (query.details) {
          this.onDetails = query.details === "true";
        }

        if (!this.onDetails) {
          this.stealCoverImageColors();

          nextTick(() => {
            // this.initCroppr(false);
          });

          setTimeout(() => {
            this.initColorPicker();
          }, 1500);
        }
      }
    },
    selectPaletteColor(color) {
      this.stepForm.background_color = color;
    },
    selectTextColor(color) {
      this.stepForm.text_color = color;
    },
    initColorPicker() {
      if (!$("#color-picker").length) {
        return;
      }

      this.colorPicker = null;

      const vm = this;

      this.colorPicker = new jscolor("#color-picker", {
        onChange: function () {
          vm.stepForm.background_color = this.toHEXString();
        },
      });
    },
    stealCoverImageColors() {
      nextTick(() => {
        const imageEl = this.coverImageRef;

        if (!imageEl) {
          return;
        }

        const thief = new ColorThief();

        imageEl.onload = () => {
          const palette = thief
            .getPalette(imageEl)
            .map((rgb) => this.rgbToHex(rgb))
            .filter((color) => !hex_is_light(color) && color !== "#ffffff");

          const color = this.rgbToHex(thief.getColor(imageEl));

          this.colorPalette = [color];
          this.colorPalette = [
            ...this.colorPalette,
            ...[...palette.slice(0, 3), ...palette.slice(-3)],
          ];
          this.colorPalette = this.colorPalette.filter(
            (color, index) => this.colorPalette.indexOf(color) === index
          );

          if (!this.stepForm.background_color) {
            this.stepForm.background_color = color;
          }
        };
      });
    },
    setOnDetails(on) {
      this.onDetails = on;
    },
    setPixabayImage(image) {
      this.stepForm.pixabay_image = image;

      if (image && image.length) {
        nextTick(() => {
          this.initCroppr();
        });
      } else {
        window.eventBus.emit("croppingImage", false);
      }
    },
    setPixabayQuery(query) {
      this.pixabayQuery = query;
    },
    cancelPixabayImage() {
      this.stepForm.name_position = "bottom";
      this.stepForm.pixabay_image = "";
      this.stepForm.lecturer_image_changed = true;
      this.stepForm.middle_image_changed = true;
      this.stepForm.bottom_image_changed = true;
      window.eventBus.emit("croppingImage", false);
    },
    cancelImageUpload() {
      this.stepForm.name_position = "bottom";
      this.stepForm.cover_image = null;
      this.uploadImageErrors.clear();
      this.$refs.imageFile.value = "";
      this.stepForm.lecturer_image_changed = true;
      this.stepForm.middle_image_changed = true;
      this.stepForm.bottom_image_changed = true;
      window.eventBus.emit("croppingImage", false);
    },
    async onImageSelect(e) {
      this.stepForm.has_no_image = false;
      this.stepForm.pixabay_image = "";

      const file = e.target.files[0];

      this.stepForm.cover_image = null;
      this.uploadImageErrors.clear();

      if (!file) {
        window.eventBus.emit("croppingImage", false);
        return;
      }


      // בדיקת סוג קובץ
      if (!file.type.startsWith('image/')) {
        this.toast.error(this.$trans("validation.image"), this.$trans("event.create.validation_image_type"));
        this.$refs.imageFile.value = ""; // אפס את הקלט
        return;
      }

      // בדיקת גודל קובץ (לדוגמה, 5MB)
      const maxFileSize = 15 * 1024 * 1024; // 5MB
      if (file.size > maxFileSize) {
        console.log("file size", file.size);
        // השתמש ב-uploadImageErrors להצגת השגיאה מתחת לכפתור, או ב-toast להודעה קופצת
        this.uploadImageErrors.set('file', this.$trans("validation.max.file", { max: '5MB' }));
        // או: this.toast.error(this.$trans("validation.file_too_large"), this.$trans("validation.max.file", { max: '5MB' }));
        this.$refs.imageFile.value = ""; // אפס את הקלט
        return;
      }


      this.uploadingImage = true;

      const response = await this.$api.postFile("upload-image", file);

      this.uploadingImage = false;

      if (response.hasErrors()) {
        window.eventBus.emit("croppingImage", false);
        this.$refs.imageFile.value = "";
        this.uploadImageErrors = response.errors(); // הצג שגיאות מהשרת אם יש
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        this.stepForm.cover_image = e.target.result;

        nextTick(() => {
          this.initCroppr();
        });
      };

      reader.readAsDataURL(file);
    },
    toggleTimes() {
      this.stepForm.has_event_times = !this.stepForm.has_event_times;

      if (this.stepForm.has_event_times) {
        nextTick(() => {
          this.initTimePickers();
        });
      } else {
        this.stepForm.start_time = null;
        this.stepForm.end_time = null;

        this.timePickers.start_time.clear();
        this.timePickers.end_time.clear();
      }
    },
    toggleDates() {
      this.stepForm.has_event_dates = !this.stepForm.has_event_dates;

      if (this.stepForm.has_event_dates) {
        nextTick(() => {
          this.initPickers();
        });
      } else {
        this.stepForm.start_date = null;
        this.stepForm.end_date = null;

        this.datePickers.start_date.clear();
        this.datePickers.end_date.clear();
      }
    },
    clearStartDate() {
      this.stepForm.start_date = null;
      this.datePickers.start_date.clear();
    },
    clearEndDate() {
      this.stepForm.end_date = null;
      this.datePickers.end_date.clear();
    },
    clearStartTime() {
      this.stepForm.start_time = null;
      this.timePickers.start_time.clear();
    },
    clearEndTime() {
      this.stepForm.end_time = null;
      this.timePickers.end_time.clear();
    },
    initTimePickers() {
      this.initTimePicker("#start_time");
      this.initTimePicker("#end_time");
    },
    initDatePicker(element, minDate = null) {
      const elObj = element.toString().substr(1, element.length);

      this.datePickers[elObj] = this.flatpickr(element, {
        minDate: minDate ? minDate : new Date(),
        onChange: (selectedDate) => {
          if (element === "#start_date") {
            this.initDatePicker("#end_date", selectedDate[0]);
          }
        },
        onOpen: () => {
          window.eventBus.emit("sideBySide", "info_bar");
        },
      });
    },
    initTimePicker(element) {
      const elObj = element.toString().substr(1, element.length);

      this.timePickers[elObj] = this.flatpickr(element, {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        onOpen: () => {
          window.eventBus.emit("sideBySide", "info_bar");

          if (!this.stepForm[elObj]) {
            this.stepForm[elObj] = "12:00";
          }
        },
      });
    },
    initPickers(dateOnly = false) {
      this.initDatePicker("#start_date");
      this.initDatePicker("#end_date");

      if (this.stepForm.has_event_times && !dateOnly) {
        nextTick(() => {
          this.initTimePickers();
        });
      }
    },
  },
  computed: {
    classOne() {
      return this.stepForm.type == "contact_me" ? "class-one" : "class-two";
    },
    addTimes() {
      return this.stepForm.has_event_times
        ? `- ${this.$trans("event.create.remove_event_times")}`
        : `+ ${this.$trans("event.create.add_event_times")}`;
    },
    addDates() {
      return this.stepForm.has_event_dates
        ? `- ${this.$trans("event.create.remove_event_dates")}`
        : `+ ${this.$trans("event.create.add_event_dates")}`;
    },
    coverImageRef() {
      const coverImage = document.querySelector("#coverImage");
      const pixabayImage = document.querySelector("#pixabayImage");

      return this.stepForm.cover_image
        ? coverImage
        : this.stepForm.pixabay_image
          ? pixabayImage
          : false;
    },
  },
};
</script>
<style scoped lang="scss">
.flatpickr-calendar {
  position: absolute;
  /* Default positioning that might need adjustment */
  z-index: 999999;
}

.form-group {
  position: relative;
  /* Add this if not present */
}

.flex-items {
  display: flex;
  position: relative;
}

.flex-item {
  position: relative;

  /* Add specific positioning for LTR/RTL layouts */
  &.en-class {
    margin-right: 10px;
  }

  &.he-class {
    margin-left: 10px;
  }
}

/* Add custom positioning for the flatpickr calendar */
:deep(.flatpickr-calendar) {
  position: absolute;
  top: 100%;
  /* Position below the input */
  left: 0;
  /* For LTR */
  right: 0;
  /* For RTL */
  margin-top: 2px;
  z-index: 999999;
}

/* RTL support */
.he-class {
  :deep(.flatpickr-calendar) {
    right: 0;
    left: auto;
  }
}

.class-one {
  display: none;
}

.class-two {
  display: block;
}

.en-class .event-details-tabs div {
  // display: flex;
  margin-left: 7px;
  margin-right: 0px !important;
}

.en-class .middle-element-toggle {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  margin-left: 10px;
}

.en-class .extra-description-toggle {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  margin-left: 10px;
}

.en-class .lecturer-toggle {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  margin-left: 10px !important;
}

.en-class .fields-select-body ul.fields-list li label span {
  margin-right: 10px !important;
}

.he-class .fields-select-body ul.fields-list li label span {
  margin-left: 10px;
}

.en-class .event-details .event-type-select .type-select-dropdown:after {
  right: 20px;
}

.he-class .event-details .event-type-select .type-select-dropdown:after {
  left: 20px;
}

.he-class .selected-icon {
  right: 12px;
}

.en-class .selected-icon {
  left: 12px;
}

.en-class .type-select-dropdown {
  padding-left: 62px;
}

.he-class .type-select-dropdown {
  padding-right: 62px;
}

/* Positioning container */
.flex-items.force {
  position: relative;
  z-index: 9999;
}

.flex-item {
  position: relative;
  width: 100%;
}



/* Input field styling */
.app-input {
  position: relative;
  width: 100%;
}

/* RTL Support */
.he-class {
  .flex-item {
    margin-left: 10px;
  }

  :deep(.flatpickr-calendar) {
    direction: rtl;
  }
}

.en-class {
  .flex-item {
    margin-right: 10px;
  }
}
</style>
